﻿export class Condition {
    operation: string;
    value: any;
}

export interface ICondition {
    $type: string;
    operation: string;
    value: any;
}

export class ConditionOfString implements ICondition {
    $type = 'Core.ConditionOfString';
    operation: string;
    value: string;
}

export class ConditionOfInt implements ICondition {
    $type = 'Core.ConditionOfInt';
    operation: string;
    value: number;
}

export class ConditionOfDateTime implements ICondition {
    $type = 'Core.ConditionOfDateTime';
    operation: string;
    value: string;
}

export class Offset {
    offsetType: string;
    offsetValue: number;
}

export class ConditionOfTimeSpan implements ICondition {
    $type = 'Core.ConditionOfTimeSpan';
    operation: string;
    value: any;
    valueAsOffset : Offset;
}

export class ConditionOfWorkItemState implements ICondition {
    $type = 'Core.ConditionOfWorkItemState';
    operation: string;
    value: string;
}

export class ConditionOfWorkItemStates implements ICondition {
    $type = 'Core.ConditionOfWorkItemStates';
    operation: string;
    value: WorkItemStates;
}

export class ConditionOfInts implements ICondition {
    $type = 'Core.ConditionOfInts';
    operation: string;
    value: number[];
}

export class WorkItemStates {
    $type = 'System.Collections.Generic.List`1[[Core.WorkItemState]], mscorlib';
    $values: string[];
}